var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.03125H4.16667C3.72464 3.03125 3.30072 3.20684 2.98816 3.51941C2.67559 3.83197 2.5 4.25589 2.5 4.69792V8.03125M7.5 3.03125H15.8333C16.2754 3.03125 16.6993 3.20684 17.0118 3.51941C17.3244 3.83197 17.5 4.25589 17.5 4.69792V8.03125M7.5 3.03125V18.0312M2.5 8.03125V16.3646C2.5 16.8066 2.67559 17.2305 2.98816 17.5431C3.30072 17.8557 3.72464 18.0312 4.16667 18.0312H7.5M2.5 8.03125H17.5M17.5 8.03125V16.3646C17.5 16.8066 17.3244 17.2305 17.0118 17.5431C16.6993 17.8557 16.2754 18.0312 15.8333 18.0312H7.5",
    stroke: "#67768E",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeader);
export default __webpack_public_path__ + "static/media/TableHeader.73a7169d44cb1bc6cf4b8326cba52173.svg";
export { ForwardRef as ReactComponent };